
import circleImage from "../../assets/images/company/circle-image.png";
import { useHistory } from "../../router/useHistory";
import startFreeTrialIcon from "../../assets/images/company/start-free-trial.png";
import { i18n } from "../../pages/private/languageSelector";
import useActionLock from "../../hooks/useActionLock";

const PremiumFeatureDialog = ({
  onClose,
  onTrialStart,
  onSubscribe,
  subscriptionData,
}) => {
  const history = useHistory();
  const [locked, runAction] = useActionLock();

  const handleOutsideClick = (e) => {
    if (e.target.id === "default-modal") {
      onClose();
    }
  };

  const isUserInFreeFreePlan =
    subscriptionData?.currentPlan?.plan === "Free" &&
    subscriptionData?.userTrial?.isTrialCancelled === false &&
    subscriptionData?.userTrial?.isTrialExpired === false;

  const handleSubscribeClick = () => {
    if (onSubscribe) {
      onSubscribe();
    } else {
      history.push("/management/subscriptions");
    }
  };

  return (
    <div
      onClick={handleOutsideClick}
      id="default-modal"
      tabIndex="-1"
      aria-hidden="true"
      className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50 z-50"
    >
      <div
        className={`bg-white px-4 pt-4 pb-4 rounded-[10px] shadow-custom w-[350px] flex flex-col items-center`}
      >
        <p className="font-semibold text-[18px] text-[#333333] mb-3 ">
          {i18n("Modals.PremiumFeature")}
        </p>
        <p className="text-center mt-2 text-sm">
          {isUserInFreeFreePlan
            ? i18n("Modals.StartFreeTrial")
            : i18n("Modals.SubscribeBenefit")}
        </p>
        {isUserInFreeFreePlan ? (
          <button
            disabled={locked}
            onClick={() => runAction(onTrialStart)}
            className="w-[186px] h-[40px] bg-[#2D9CDB] mt-3 rounded-xl focus:outline-none flex items-center justify-center gap-3"
          >
            <span className="text-white font-semibold text-sm">
              {i18n("global.StartFreeTrial")}
            </span>
            <img
              src={startFreeTrialIcon}
              alt="startFreeTrialIcon"
              className="w-5 h-5"
            />
          </button>
        ) : (
          <button
            onClick={handleSubscribeClick}
            className="w-[186px] h-[40px] bg-[#2D9CDB] mt-3 rounded-xl focus:outline-none flex items-center justify-center gap-3"
          >
            <span className="text-white font-semibold text-sm">
              {i18n("Subscriptions.Subscribe")}
            </span>
          </button>
        )}
        <div className="text-center mt-3 flex items-center gap-2">
          <img src={circleImage} alt="circleImage" className="w-1 h-1" />
          <span className="text-sm">{i18n("Modals.AdvancedAnalytics")}</span>
        </div>
        <div className="text-center mt-1 flex items-center gap-2">
          <img src={circleImage} alt="circleImage" className="w-1 h-1" />
          <span className="text-sm my-2">{i18n("Modals.ManageRolesPermissions")}</span>
        </div>
        <div className="text-center mt-1 flex items-center gap-2">
          <img src={circleImage} alt="circleImage" className="w-1 h-1" />
          <span className="text-sm">{i18n("Modals.UnlimitedNumberTeamMembers")}</span>
        </div>
      </div>
    </div>
  );
};

export default PremiumFeatureDialog;
